import { render } from "./DataPage.vue?vue&type=template&id=61e9302e&scoped=true"
import script from "./DataPage.vue?vue&type=script&lang=js"
export * from "./DataPage.vue?vue&type=script&lang=js"

import "./DataPage.vue?vue&type=style&index=0&id=61e9302e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e9302e"]])

export default __exports__